import React, { Component } from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import get from 'lodash/get'
import isNil from 'lodash/isNil'
import BackgroundImage from './BackgroundImage'
import ProductLink from './phoneContent/ProductLink'

const IAContainer = styled.div`
  & > div i {
    opacity: 1
  }

  & > div span {
    opacity: 1;
    color: black;
    transform: none;
  }
`

export default class PhoneContent extends Component {

  constructor (props) {
    super(props)
    this.state = {
      popoverActive: false
    }
  }

  componentDidMount () {
    this.setState({popoverActive: true})
  }

  renderProductLink = (product, idx) => {
    const { showcase, changeProductIdx, enableLinkMoveMode, isMoveMode, productIdx, updateProduct, productLinksEditable } = this.props
    const { popoverActive } = this.state
    const firstProductSet = !isNil(get(showcase, ['products', 0, 'productId']))
    // console.log('showcase', showcase, 'productId:', get(showcase, ['products', 0, 'productId']))
    const linkIsActive = idx === 0 || (idx === 1 && firstProductSet)
    // console.log('idx', idx, 'firstProductSet', firstProductSet, 'linkIsActive', linkIsActive)
    return (
      <ProductLink
        key={idx}
        product={product}
        idx={idx}
        showcase={showcase}
        changeProductIdx={changeProductIdx}
        enableLinkMoveMode={enableLinkMoveMode}
        isMoveMode={isMoveMode}
        productIdx={productIdx}
        popoverActive={popoverActive && linkIsActive}
        updateProduct={updateProduct}
        productLinksEditable={productLinksEditable}
      />
    )
  }

  render () {
    const { slideId, showcase } = this.props
    // console.log('Phone content render, showcase', showcase)
    return (
      <IAContainer>
        <BackgroundImage slideId={slideId} imageUrl={showcase.image} />
        {showcase.products && showcase.products[0] && showcase.products.map(this.renderProductLink)}
      </IAContainer>
    )
  }
}

PhoneContent.propTypes = {
  slideId: PropTypes.string.isRequired,
  showcase: PropTypes.object.isRequired,
  productIdx: PropTypes.number.isRequired,
  changeProductIdx: PropTypes.func.isRequired,
  isMoveMode: PropTypes.bool.isRequired,
  enableLinkMoveMode: PropTypes.func.isRequired,
  updateProduct: PropTypes.func.isRequired,
  productLinksEditable: PropTypes.bool.isRequired
}



// WEBPACK FOOTER //
// ./src/components/shopifyApp/shopifyWizard/productsSlideWizard/PhoneContent.js